import { AppConstants } from '../app.constants';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Galeri } from "app/model/galeri.model";
import { CustomHttp } from "app/customhttp";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import { UyeDurum } from "app/enum/uye-durum.enum";
import {HttpClient, HttpResponse} from '@angular/common/http';
import {GaleriModel} from '../model/spring-model/galeri.model';
import {TeklifModel} from '../model/spring-model/teklif.model';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class GaleriService {

  public _galeriSubject: BehaviorSubject<GaleriModel>;

  constructor(private https: HttpClient, private  authService: AuthenticationService) {
    this._galeriSubject = <BehaviorSubject<GaleriModel>>new BehaviorSubject(undefined);
  }

  getGaleriSubject() {
    return this._galeriSubject.asObservable();
  }

  sendGaleriMessage(galeri: GaleriModel) {
    this._galeriSubject.next(Object.assign({}, galeri));
  }
  // Spring backend kullanımı buradan ihtibaren basladi
  public getGaleriCountS() {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/count/';
    return this.https.get<Number>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  public getGaleriListS(): Observable<HttpResponse<GaleriModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/';
    return this.https.get<GaleriModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  public getGaleriListPaginationS(size: number, page: number): Observable<HttpResponse<GaleriModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/page/' + page + '/size/' + size;
    return this.https.get<GaleriModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  public getGaleriByIdS(id: number): Observable<HttpResponse<GaleriModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/' + id;
    return this.https.get<GaleriModel>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  public updateGaleriS(galeri: GaleriModel): Observable<HttpResponse<GaleriModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/';
    return this.https.put<GaleriModel>(apiURL, galeri, {observe: 'response', headers: this.authService.getHeader()});
  }

  public saveGaleriS(galeri: GaleriModel): Observable<HttpResponse<GaleriModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/';
    return this.https.post<GaleriModel>(apiURL, galeri, {observe: 'response', headers: this.authService.getHeader()});
  }

  public updateGaleriPass(galeri: GaleriModel, pass: String): Observable<HttpResponse<GaleriModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/id/' + galeri.id + '/pass/' + pass + '/old/' + galeri.passw;
    return this.https.get<GaleriModel>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }

  public removeGaleriS(galeriId: number): Observable<HttpResponse<GaleriModel>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/' + galeriId;
    return this.https.delete<GaleriModel>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
  public getTeklifByGaleri(galeriId: number): Observable<HttpResponse<TeklifModel[]>> {
    const apiURL = AppConstants.API_ENDPOINT_SPRING + 'galeri/teklif/' + galeriId;
    return this.https.get<TeklifModel[]>(apiURL, {observe: 'response', headers: this.authService.getHeader()});
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/service/galeri.service.ts